import React from 'react';
import './Business.css'
import PAW from '../../Images/paw.png'


class Business extends React.Component {
 
  render() {
    return (
      <div className="Business">
        <div className="image-container">
        <a href={this.props.business.url}>
          {/* accessed information via the business prop set in businesslist.js */}
          <img src={PAW} alt='' className="pawprint"/></a>
        </div>
        <h2>{this.props.business.name}</h2>
        <div className="Business-information">
          <div className="Business-address">
            <p>{this.props.business.phone}</p>
            <p>{this.props.business.address}</p>
            <p>{this.props.business.city}</p>
            <p>{`${this.props.business.state} ${this.props.business.zipCode}`}</p>
          </div>
          <div className="Business-reviews">
            <h3 className="rating">{`${this.props.business.rating} stars`}</h3>
            
          </div>
        </div>
      </div>
    );
  }
};
  
  export default Business;
  